import { ORM } from 'redux-orm';

import {
  Activity,
  Attachment,
  Board,
  BoardMembership,
  Card,
  // FAMILY-EXT: feature 1+2
  CardWaitingAction,
  Label,
  List,
  Notification,
  Project,
  ProjectManager,
  Task,
  User,
} from './models';

const orm = new ORM({
  stateSelector: (state) => state.orm,
});

orm.register(
  User,
  Project,
  ProjectManager,
  Board,
  BoardMembership,
  Label,
  List,
  Card,
  Task,
  Attachment,
  Activity,
  Notification,
  // FAMILY-EXT: feature 1+2
  CardWaitingAction,
);

export default orm;
